"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;

var _colors = require("./colors");

var typography = {
  baseFontSize: '16px',
  baseLineHeight: 1.5,
  scaleRatio: 3,
  googleFonts: [],
  headerFontFamily: ['Mr Eaves', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
  bodyFontFamily: ['Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
  headerColor: _colors.colors.black,
  bodyColor: _colors.colors.black,
  headerWeight: 'normal',
  bodyWeight: 500,
  boldWeight: 'bold',
  blockMarginBottom: 1,
  includeNormalize: false,
  overrideStyles: function overrideStyles() {
    return {};
  }
};
exports.typography = typography;